'use client';

import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { useRouter, usePathname } from 'next/navigation';

// Create the Auth Context
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
const [user, setUser] = useState(null);
const [token, setToken] = useState(null);
const [loading, setLoading] = useState(true); // To indicate if initial loading of token is complete
const router = useRouter();
const pathname = usePathname();

// Effect to load token from localStorage on component mount
useEffect(() => {
const storedToken = localStorage.getItem('AUTH_TOKEN');
if (storedToken) {
setToken(storedToken);
// In a real application, you would typically decode the token or make an API call
// to /api/user to get user data. For this task, we'll just set the token.
// For now, setting a dummy user if token exists
setUser({ id: 1, email: 'test@user.com' }); // Placeholder user data
}
setLoading(false);
}, []);

// Временно отключен эффект перенаправления для неавторизованных пользователей
/*
useEffect(() => {
if (!loading) {
// Define routes that do not require authentication
const publicRoutes = ['/', '/login', '/register']; // Added '/' to public routes
const isProtectedRoute = !publicRoutes.includes(pathname);

if (!token && isProtectedRoute) {
router.push('/login');
} else if (token && (pathname === '/login' || pathname === '/register')) {
router.push('/dashboard'); // Redirect logged-in users away from login/register pages
}
}
}, [token, loading, pathname, router]);
*/

const login = useCallback((newToken) => {
localStorage.setItem('AUTH_TOKEN', newToken);
setToken(newToken);
// For a real app, fetch user data here using the newToken
setUser({ id: 1, email: 'test@user.com' }); // Placeholder user data
router.push('/dashboard');
}, [router]);

const logout = useCallback(() => {
localStorage.removeItem('AUTH_TOKEN');
setToken(null);
setUser(null);
router.push('/login');
}, [router]);

// Memoize the value to prevent unnecessary re-renders of consumers
const authContextValue = React.useMemo(() => ({
user,
token,
login,
logout,
isAuthenticated: !!token,
loading, // Provide loading state
}), [user, token, login, logout, loading]);

if (loading) {
// Optionally render a loading spinner or null while checking auth state
return null;
}

return (
<AuthContext.Provider value={authContextValue}>
    {children}
</AuthContext.Provider>
);
};

// Custom hook to consume the AuthContext
export const useAuth = () => {
const context = useContext(AuthContext);
if (context === undefined) {
throw new Error('useAuth must be used within an AuthProvider');
}
return context;
};
